import ReceiptModal from './component';

export default ReceiptModal;
